import { defineStore } from 'pinia'

export const useFlashStore = defineStore('flash', {
  state: () => ({ message: '' }),
  actions: {
    set(msg) { this.message = msg },
    clear() { this.message = '' }
  }
})
